export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      color: 'bg-primary-100 text-primary-600',
      title: '安全合规',
      desc: '持有国家正规彩票销售资质，资金由银行托管，交易全程加密，保障用户资金安全。',
    },
    {
      icon: 'ri-flashlight-line',
      color: 'bg-accent-100 text-accent-600',
      title: '极速到账',
      desc: '中奖奖金秒级到账，支持微信、支付宝、银行卡多种提现方式，到账速度行业领先。',
    },
    {
      icon: 'ri-stack-line',
      color: 'bg-secondary-100 text-secondary-600',
      title: '玩法齐全',
      desc: '涵盖双色球、大乐透、快三、福彩3D、排列三、时时彩等十余种主流彩票玩法。',
    },
    {
      icon: 'ri-customer-service-2-line',
      color: 'bg-primary-100 text-primary-600',
      title: '贴心服务',
      desc: '7×24小时专业客服团队，在线答疑、购彩指导、中奖提醒，全心全意为彩民服务。',
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      color: 'bg-accent-100 text-accent-600',
      title: '数据精准',
      desc: '实时同步官方开奖数据，历史开奖号码完整可查，走势图表专业详尽，助您理性投注。',
    },
  ];

  return (
    <section id="features" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择BB彩票平台
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            五大核心优势，打造值得信赖的购彩体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${feature.color}`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-2 text-sm">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}